export enum FloorplanIconName {
  Door = 'door',
  Window = 'window',
  Frameout = 'frameout',
  WallClosed = 'wall-closed',
  WallOpen = 'wall-open',
  Loft = 'loft',
}
